import { CMSApiBase, CMSGroupParams, CMSImageBase, createCmsUrl } from './base';
import { fetcherCMS } from '@/modules/api';
import { getCMSLocale } from '@/modules/cms';

export interface VipBenefit {
  title: string;
  image: CMSImageBase;
}

export interface BecomeVipSection {
  title: string;
  description: string;
}

export interface VipCardBenefitContent {
  description: string;
  descriptionSuperSpot: string;
  vipType: string;
  locked: boolean;
  lockedSuperSpot: boolean;
}

export interface VipCardBenefit {
  title: string;
  benefitContent: VipCardBenefitContent[];
}

interface TextByGroup extends CMSGroupParams {
  text: string;
}

export interface SuperSpotBannerContent {
  title: string;
  description: string;
  vipType: string;
}

export interface SuperSpotModalTitleContent {
  title: string;
  vipType: string;
}

export interface VipApi extends CMSApiBase {
  title: string;
  titleH1: string;
  vipBenefits: VipBenefit[];
  vipCardBenefits: VipCardBenefit[];
  howBecomeVip: BecomeVipSection;
  pageDescriptionV2: TextByGroup[];
  termsAndConditionsV2: TextByGroup[];
  superSpotBanners: SuperSpotBannerContent[];
  superSpotModalTitles: SuperSpotModalTitleContent[];
  missionEndedText: string;

  // TODO: rm after v2 fields are filled on prod
  pageDescription: string;
  termsAndConditions: string;
}

export const getVipCMSUrl = (lang: string) =>
  createCmsUrl({
    path: 'vip-v-3',
    queryData: { populate: 'deep', ...getCMSLocale(lang) },
  });

export const fetchVipCMS = async (lang: string) => {
  const response = await fetcherCMS<VipApi>(getVipCMSUrl(lang));
  return { data: response };
};
